import { PAGE_PATH } from '@/constants';

export default {
  /** 判断当前页面是否tabbar页 */
  is: () => {
    const pages = getCurrentPages();
    const curPage = pages[pages.length - 1];

    if (!curPage.route) return false;

    return [
      PAGE_PATH.home.route,
      PAGE_PATH.classify.route,
      PAGE_PATH.member.route,
      PAGE_PATH.cart.route,
      PAGE_PATH.self.route,
    ].includes(`/${curPage.route}`);
  },
};
